import { axios } from "@/plugins/axios";

function KFZPromoSubmit(code, iban) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=KFZPromoSubmit",
        "code=" + code + "&iban=" + iban
    );
}

export { KFZPromoSubmit };
